// extracted by mini-css-extract-plugin
export default {"home":"home_Iyqi","imageContainer":"imageContainer_JZdr","introduce":"introduce_Zmp3","title":"title_aWvm","description":"description_i9_M"};